import axios from 'axios';

//单位基本信息查询
function Api_comDwjbxxcx(dwzh) {
  return new Promise((resolve,reject) =>{
    axios.post('/ej-isp-api/zk/ywcx/dwjbxxcx', {}, {
      data: {
        para: {
          "jydm": "2006",
          "extParam": {
            "dwzh": dwzh
          }
        }
      }
    }).then(res =>{
      //获取成功
      resolve(res.data);
    }).catch(error =>{
      //获取失败
      console.log(error);
      reject(error);
    })
  })
}
//单位账户信息查询
function Api_comDwzhxxcx(dwzh) {
  return new Promise((resolve,reject) =>{
    axios.post('/ej-isp-api/zk/ywcx/dwzhxxcx', {}, {
      data: {
        para: {
          "jydm": "2105",
          "extParam": {
            "dwzh": dwzh
          }
        }
      }
    }).then(res =>{
      //获取成功
      resolve(res.data);
    }).catch(error =>{
      //获取失败
      console.log(error);
      reject(error);
    })
  })
}
//单位明细信息查询
function Api_comDwmxcx(obj={}) {
  let dwzh = obj.dwzh || null;
  let page = obj.page || 1;
  let count = obj.count || 10;
  let ywmxlx = obj.ywmxlx || null;
 //日期未处理，需修改格式。
  let ksrq = obj.ksrq || null;
  let jsrq = obj.jsrq || null;

  return new Promise((resolve,reject) =>{
    axios.post('/ej-isp-api/zk/ywcx/dwmxcx', {}, {
      data: {
        para: {
          "jydm": "2007",
          "extParam": {
            "dwzh": dwzh,
            "page": page,
            "count": count,
            "ywmxlx": ywmxlx,
            "ksrq": ksrq,
            "jsrq": jsrq,
          }
        }
      }
    }).then(res =>{
      //获取成功
      resolve(res.data);
    }).catch(error =>{
      //获取失败
      console.log(error);
      reject(error);
    })
  })
}
//账户列表查询（单位列表）
function Api_comDwzhlbcx(sfzh=null) {
  return new Promise((resolve,reject) =>{
    axios.post('/ej-isp-api/zk/ywcx/zhlbcx', {}, {
      data: {
        para: {
          "jydm": "5006",
          "extParam": {
            "sfzh": sfzh
          }
        }
      }
    }).then(res =>{
      //获取成功
      resolve(res.data);
    }).catch(error =>{
      //获取失败
      console.log(error);
      reject(error);
    })
  })
}


export {
  Api_comDwjbxxcx,
  Api_comDwzhxxcx,
  Api_comDwzhlbcx,
  Api_comDwmxcx
}



// WEBPACK FOOTER //
// ./src/static/js/api/com/cominfo.js